var _circle, _path, _line;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAboveAvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#45941E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0254 10.8077L10.0263 10.8068L14.0642 6.7523C14.1949 6.63147 14.3767 6.64693 14.4759 6.74606C14.4759 6.74606 14.4759 6.74607 14.4759 6.74607L18.5309 10.8012C18.6521 10.9319 18.6367 11.114 18.5375 11.2132L19.0089 11.6846L18.5375 11.2132C18.4726 11.2782 18.4065 11.3009 18.3431 11.3009C18.2902 11.3009 18.2091 11.2736 18.1487 11.2132L15.7017 8.76625L14.5637 7.62818V9.23765V17.361C14.5637 17.5089 14.4293 17.6432 14.2814 17.6432C14.1259 17.6432 13.9992 17.518 13.9992 17.361V9.23765V7.62035L12.8595 8.76787L10.4368 11.2072C10.3083 11.3258 10.1304 11.3128 10.0303 11.2181C9.91087 11.0875 9.92657 10.9065 10.0254 10.8077Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.33333
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 21.25,
    x2: 19.8126,
    y2: 21.25,
    stroke: "white",
    strokeWidth: 1.5,
    strokeDasharray: "2 2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboveAvg);
export default __webpack_public_path__ + "static/media/above-avg.6737648ce1e5925af76c55007a397320.svg";
export { ForwardRef as ReactComponent };